// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EpicPlayer-wrapper_bce0c149"};